import request from "@/utils/request";

export const createInventoryPlans = (data: { deliveryNoteIds: string[] }) =>
    request({
        url: `/inventory-plans`,
        method: "POST",
        data,
    });

export const queryInventoryPlans = (params: any) =>
    request({
        url: `/inventory-plans`,
        method: "GET",
        params,
    });

// 盘库详情
export const getInventoryPlans = (id: string) =>
    request({
        url: `/inventory-plans/${id}`,
        method: "GET",
    });
// 盘库详情
export const deleteInventoryPlans = (id: string) =>
    request({
        url: `/inventory-plans/customs-packing/${id}`,
        method: "DELETE"
    });

// 补充包装信息
export const editPalnPackages = (id: string, data: any) =>
    request({
        url: `/inventory-plans/packages/${id}`,
        method: "PUT",
        data,
    });
// 一键确认主包装盘库
export const confirmCustomsPacking = (id: string, data: any) =>
    request({
        url: `/inventory-plans/${id}/customs-packing-set/inventory-state`,
        method: "PUT",
        data,
    });
// 查询主包装异常历史记录
export const historyProblemCustomsPacking = (id: string, params: any) =>
    request({
        url: `/hq-packing-lists/${id}/history-customs-packing-problem`,
        method: "GET",
        params,
    });

// 查询盘库的异常确认列表
export const getProblemCustomsPlans = (id: string) =>
    request({
        url: `/inventory-plans/${id}/problem-customs-packing-list`,
        method: "GET",
    });

// 查询确认入库的列表
export const getConfirmPlans = (id: string) =>
  request({
    url: `/inventory-plans/${id}/to-be-confirm`,
    method: "GET",
  });